import { Box, ITheme, useTheme } from '@mui/material'
import React from 'react'

export interface IProgressBarProps{
    proportion: number;
}

const ProgressBar: React.FC<IProgressBarProps> = ({proportion}) => {
    const theme = useTheme() as ITheme;
    return <Box display={"flex"} width={"100%"} height={"9px"} bgcolor={theme.palette.primary.main} borderRadius={"10px"}>
            <Box height={"100%"} width={`${proportion*100}%`} borderRadius={"10px"} bgcolor={theme.palette.primary.dark} />
        </Box>
}

export default ProgressBar